<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import LaisModal from 'dashboard/components-next/LaisModal.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  state: { type: String, default: 'success' }, // 'success' | 'blocked'
  agent: { type: Object, default: null },
});

const emit = defineEmits([
  'close',
  'chat-with-agent',
  'check-my-agents',
  'browse-imoveis',
  'open-profiling',
]);

const title = computed(() =>
  props.state === 'blocked'
    ? 'Não conseguimos atribuir este corretor agora'
    : 'Tudo pronto!'
);

const description = computed(() =>
  props.state === 'blocked'
    ? 'Mantemos seu corretor atual ativo. Você pode conversar com ele, consultar seus corretores ou seguir buscando imóveis.'
    : 'O corretor responsável foi confirmado para você.'
);
</script>

<template>
  <LaisModal :show="show" :title="title" max-width-class="max-w-[480px]" @close="emit('close')">
    <p class="text-[13px] leading-6 text-lais-text-muted">{{ description }}</p>
    <p v-if="agent?.name" class="mt-3 text-[14px] font-semibold text-lais-text">
      Corretor: {{ agent.name }}
    </p>
    <template #footer>
      <div class="flex flex-wrap justify-end gap-2">
        <LaisPrimaryButton
          v-if="agent?.name"
          icon="i-lucide-message-circle"
          @click="emit('chat-with-agent', agent)"
        >
          Conversar com {{ agent.name }}
        </LaisPrimaryButton>
        <LaisPrimaryButton variant="ghost" icon="i-lucide-users" @click="emit('check-my-agents')">
          Consultar meus corretores
        </LaisPrimaryButton>
        <LaisPrimaryButton variant="ghost" icon="i-lucide-search" @click="emit('browse-imoveis')">
          Buscar imóveis
        </LaisPrimaryButton>
        <LaisPrimaryButton variant="ghost" icon="i-lucide-target" @click="emit('open-profiling')">
          Atualizar profiling
        </LaisPrimaryButton>
      </div>
    </template>
  </LaisModal>
</template>
